export default function handleOnImageError(e, fallbackImage) {
  e.currentTarget.onerror = null
  e.currentTarget.src = fallbackImage
}
